<template>
  <div class="RealNameReport">
    <div v-if="ActiveName">
      <van-form @submit="onSubmit" @failed="onFailed" ref="FormRef">
        <!-- 举报主体 -->
        <van-cell-group class="form_filed" v-if="this.$route.params.id == 7">
          <div class="label"><span class="xinhao">*</span><span class="jianju">举报主体</span></div>
          <van-field v-model="form.reportSubject" name="reportSubject"  show-error='false' :rules="[{required:true,message:'必填'}]">
            <template #input>

              <span class="xingbieanniu" native-type="button" :class="form.reportSubject === '1' && 'xingbieanniudianji'" @click="form.reportSubject = '1'" >公民</span>
              <span v-if="subId != 589" class="xingbieanniu" native-type="button" :class="form.reportSubject === '2' && 'xingbieanniudianji'" @click="form.reportSubject = '2'" >法人及其他组织</span>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group class="form_filed">
          <div class="label"> <span class="xinhao">*</span><span class="jianju ">真实姓名</span></div>

          <van-field disabled name="真实姓名" :value="form.realName" placeholder="支持中英文、数字，不超过10个字" class="left_Margin">
          </van-field>
        </van-cell-group>
        <van-cell-group class="form_filed">
          <div class="label"> <span class="xinhao">*</span><span class="jianju ">性别</span></div>

          <div class="van-cell van-field van-field--error" :aria-disabled="true">
            <div class="van-cell__value van-field__value">
              <div class="van-field__body">

                <span class="xingbieanniu" native-type="button" :class="form.gender == 0 && 'xingbieanniudianji'">男</span>
                <span class="xingbieanniu" native-type="button" :class="form.gender == 1 && 'xingbieanniudianji'">女</span>
              </div>
            </div>
          </div>
        </van-cell-group>
        <!-- 从业类别 -->
        <van-cell-group class="form_filed" v-if="form.reportSubject === '1'">
          <div class="label"><span class="xinhao">*</span><span class="jianju">从业类别</span></div>

          <van-field readonly clickable name="picker" :rules="[  { required: true, message: '必填' },]" :value="exJobKindValue" placeholder="请选择" @click="showPickerExJobKind = true" class="input_box" />
          <van-popup v-model="showPickerExJobKind" position="bottom">
            <van-picker show-toolbar :columns="exJobKindList" @confirm="onConfirmsExJobKind" @cancel="showPickerExJobKind = false" />
          </van-popup>
        </van-cell-group>
        <!-- 单位类别 -->
        <van-cell-group class="form_filed" v-if="form.reportSubject === '2'">
          <div class="label"><span class="xinhao">*</span><span class="jianju">单位类别</span></div>

          <van-field readonly clickable name="picker" :rules="[  { required: true, message: '必填' },]" :value="exUnitKindValue" placeholder="请选择" @click="showPickerExUnitKind = true" class="input_box" />
          <van-popup v-model="showPickerExUnitKind" position="bottom">
            <van-picker show-toolbar :columns="exUnitKindList" @confirm="onConfirmsExUnitKind" @cancel="showPickerExUnitKind = false" />
          </van-popup>
        </van-cell-group>
        <van-cell-group class="form_filed" v-if="form.reportSubject === '2'">
          <div class="label">
            <span class="xinhao">*</span><span class="jianju">单位名称</span>
          </div>
          <van-field placeholder="单位名称不能为空，且只允许包括中文或英文" v-model="form.exUnitName" maxlength="10" class="input_box" />
        </van-cell-group>
        <van-cell-group class="form_filed">
          <div class="label"> <span class="xinhao">*</span><span class="jianju ">电子邮箱</span></div>

          <van-field disabled name="电子邮箱" :value="form.email" placeholder="请输入正确邮箱" maxlength="50" class="left_Margin">
          </van-field>
        </van-cell-group>
        <van-cell-group class="form_filed">
          <div class="label"> <span class="xinhao">*</span><span class="jianju ">手机号</span></div>

          <van-field disabled name="手机号" :value="form.phone" placeholder="请输入11位手机号" class="left_Margin">
          </van-field>
        </van-cell-group>
        <!-- 所处地域 -->
        <van-cell-group class="form_filed">
          <div class="label"><span class="xinhao">*</span><span class="jianju">所处地域</span><span class="xinhao_jianju">（所在地 / 服务地）</span></div>
          <div class="van-cell van-field noBorder">
            <van-field style="margin-right: 2vw" readonly clickable name="picker" placeholder="请选择" :value="form.Location.province ">
              <template #button>
                <span style="color: rgba(102, 102, 102, 1)">省</span>
              </template>
            </van-field>
            <van-field style="margin-right: 2vw" readonly clickable name="picker" placeholder="请选择" :value="form.Location.city">
              <template #button>
                <span style="color: rgba(102, 102, 102, 1)">市</span>
              </template>
            </van-field>
            <van-field style="margin-right: 2vw" readonly clickable name="picker" placeholder="请选择" :value="form.Location.county">
              <template #button>
                <span style="color: rgba(102, 102, 102, 1)">区/县</span>
              </template>
            </van-field>
          </div>
        </van-cell-group>
        <van-cell-group class="form_filed">
          <div class="label"> <span class="xinhao">*</span><span class="jianju">举报地域</span><span class="xinhao_jianju">（被举报内容属地）</span></div>
          <div class="van-cell van-field noBorder">
            <!-- :value="form.province_code.province ? province_list.find((v) => v.id / 1 === form.province_code.province).name: ''" -->
            <van-field style="margin-right: 2vw" readonly clickable :value="province_val" :rules="[  { required: true, message: '必填' },]" name="picker" placeholder="请选择" @click="pikerShow.province_code__province = true">
              <template #button>
                <span style="color: rgba(102, 102, 102, 1)">省</span>
              </template>
            </van-field>
            <!-- :value="form.province_code.city ? city_list.find( (v) => v.id / 1 === form.province_code.city ).name : '' " -->
            <van-field v-if="province_val != '不清楚'" style="margin-right: 2vw" readonly :rules="[  { required: true, message: '必填' },]" clickable :value="city_val" name="picker" placeholder="请选择" @click="
                    form.province_code.province &&
                      (pikerShow.province_code__city = true)
                  ">
              <template #button>
                <span style="color: rgba(102, 102, 102, 1)">市</span>
              </template>
            </van-field>
            <van-field v-if="province_val != '不清楚' && city_val != '不清楚'" style="margin-right: 2vw" readonly :rules="[  { required: true, message: '必填' },]" clickable :value="county_val" name="picker" placeholder="请选择" @click="
                    form.province_code.city &&
                      (pikerShow.province_code__county = true)
                  ">
              <template #button>
                <span style="color: rgba(102, 102, 102, 1)">区/县</span>
              </template>
            </van-field>
            <van-popup v-model="pikerShow.province_code__province" position="bottom">
              <van-picker value-key="name" show-toolbar :columns="province_list" @confirm="
                      (value) =>
                        onConfirmCity(
                          value,
                          'province_code__province',
                          'province_code__city',
                          '1'
                        )
                    " @cancel="pikerShow.province_code__province = false" />
            </van-popup>
            <van-popup v-model="pikerShow.province_code__city" position="bottom">
              <van-picker value-key="name" show-toolbar :columns="city_list" @confirm="
                      (value) =>
                        onConfirmCity(value, 'province_code__city', 'province_code__county', '2')
                    " @cancel="pikerShow.province_code__city = false" />
            </van-popup>
            <van-popup v-model="pikerShow.province_code__county" position="bottom">
              <van-picker value-key="name" show-toolbar :columns="county_list.filter(item => item.name !== '市本级')" @confirm="
                      (value) =>
                        onConfirmCity(value, 'province_code__county', '', '5')
                    " @cancel="pikerShow.province_code__city = false" />
            </van-popup>
          </div>
        </van-cell-group>
        <!-- 举报领域 -->
        <van-cell-group class="form_filed">
          <div class="label"><span class="xinhao">*</span><span class="jianju">举报领域</span></div>

          <van-field readonly clickable :rules="[  { required: true, message: '必填' },]" name="picker" :value="reportedTradeValue" placeholder="请选择" @click="showPicker = true" class="input_box" />
          <van-popup v-model="showPicker" position="bottom">
            <van-picker show-toolbar :columns="reportedTradeList" @confirm="onConfirms" @cancel="showPicker = false" />
          </van-popup>
        </van-cell-group>
        <!-- 危害小类 -->
        <van-cell-group class="form_filed">
          <div class="label"><span class="xinhao">*</span><span class="jianju">危害小类</span></div>

          <van-field readonly clickable name="picker" :rules="[  { required: true, message: '必填' },]" :value="damageSubKindValue" placeholder="请选择" @click="showPickerDamage = true" class="input_box" />
          <van-popup v-model="showPickerDamage" position="bottom">
            <van-picker show-toolbar :columns="damageSubKindList" @confirm="onConfirmDamage" @cancel="showPickerDamage = false" />
          </van-popup>
        </van-cell-group>
        <!-- 被举报平台 -->
        <van-cell-group class="form_filed">
          <div class="label"><span class="xinhao">*</span><span class="jianju">被举报平台</span></div>

          <van-field readonly clickable name="picker" :rules="[  { required: true, message: '必填' },]" :value="reportedPlatformValue" placeholder="请选择" @click="showPickerReportedPlatform = true" class="input_box" />
          <van-popup v-model="showPickerReportedPlatform" position="bottom">
            <van-picker show-toolbar :columns="reportedPlatformList" @confirm="onConfirmReportedPlatform" @cancel="showPickerReportedPlatform = false" />
          </van-popup>
        </van-cell-group>

        <!--  -->
        <div v-if="form.reportedPlatform == '0'">
          <van-cell-group class="form_filed">
            <!-- 网站名称 -->
            <div class="label"> <span class="xinhao">*</span><span class="jianju">网站名称</span></div>

            <van-field clickable name="picker" v-model="form.reportedName" maxlength='30' placeholder="请输入网站名称" class="input_box" :rules="[{ required: true, message: '必填' }]" />
          </van-cell-group>
          <!-- 有害信息所在页面详细网址 -->
          <van-cell-group class="form_filed">
            <div class="label"> <span class="xinhao">*</span><span class="jianju">有害信息所在页面详细网址</span></div>

            <van-field type="textarea" autosize name="picker" maxlength="300" v-model="form.reportedLink" placeholder="网址格式：http://www.xxx.com或https://www.xxx.com，举报多个网址请按回车键后再输入，否则无效" class="input_box" :rules="[{ required: true, message: '必填' },{ validator:this.$Common.validateInput, message: this.$Common.validateInputText }]" />
          </van-cell-group>

        </div>
        <div v-if="form.reportedPlatform == '1'">
          <!-- App名称 -->
          <van-cell-group class="form_filed">
            <div class="label"> <span class="xinhao">*</span><span class="jianju">App名称</span></div>

            <van-field name="picker" maxlength="30" v-model="form.reportedName" placeholder="请输入App名称" class="input_box" :rules="[{ required: true, message: '必填' }]" />
          </van-cell-group>
          <!-- App定位 -->
          <van-cell-group class="form_filed">
            <div class="label"><span class="xinhao">*</span><span class="jianju">App定位</span></div>

            <van-field readonly clickable name="picker" :value="targetKindValue" :rules="[  { required: true, message: '必填' },]" placeholder="请选择" @click="showPickertargetKind = true" class="input_box" />
            <van-popup v-model="showPickertargetKind" position="bottom">
              <van-picker show-toolbar :columns="targetKindList" @confirm="onConfirmtargetKind" @cancel="showPickertargetKind = false" />
            </van-popup>
          </van-cell-group>
          <!-- 有害信息所在页面详细网址 APP官网地址 APP下载地址-->
          <van-cell-group class="form_filed">
            <div class="label"> <span class="xinhao">*</span><span class="jianju">{{form.targetKind === 1?'有害信息所在页面详细网址':form.targetKind === 2?'APP官网地址':'APP下载地址'}}</span></div>

            <van-field type="textarea" autosize name="picker" maxlength="500" v-model="form.reportedLink" placeholder="网址格式：http://www.xxx.com或https://www.xxx.com，举报多个网址请按回车键后再输入，否则无效" class="input_box" :rules="[{ required: true, message: '必填' },{ validator:this.$Common.validateInput, message: this.$Common.validateInputText }]" />
          </van-cell-group>
        </div>

        <div v-if="form.reportedPlatform == '2'">
          <!--平台类型  -->
          <van-cell-group class="form_filed">
            <div class="label"><span class="xinhao">*</span><span class="jianju">平台类型</span></div>

            <van-field readonly clickable :rules="[  { required: true, message: '必填' },]" name="picker" :value="platformKindValue" placeholder="请选择" @click="showPickerplatformKind = true" class="input_box" />
            <van-popup v-model="showPickerplatformKind" position="bottom">
              <van-picker show-toolbar :columns="platformKindList" @confirm="onConfirmplatformKind" @cancel="showPickerplatformKind = false" />
            </van-popup>
          </van-cell-group>

          <div v-if="['0',1,2].indexOf(form.platformKind) > -1">
            <!-- 账号性质 -->
            <van-cell-group class="form_filed">
              <div class="label"><span class="xinhao">*</span><span class="jianju">账号性质</span></div>

              <van-field readonly clickable name="picker" :rules="[  { required: true, message: '必填' },]" :value="accountKindValue" placeholder="请选择" @click="showPickeraccountKind = true" class="input_box" />
              <van-popup v-model="showPickeraccountKind" position="bottom">
                <van-picker show-toolbar :columns="accountKindList" @confirm="onConfirmaccountKind" @cancel="showPickeraccountKind = false" />
              </van-popup>
            </van-cell-group>
          </div>
          <!-- 账号名称/ID -->
          <van-cell-group class="form_filed" v-if="['0',1,2,3,4,5,6,7,8,9].indexOf(form.platformKind) > -1">
            <div class="label"> <span class="xinhao">*</span><span class="jianju">账号名称/ID</span></div>

            <van-field name="picker" :placeholder="form.platformKind==4?'账号名称不能为空，且不超过40字符':'账号名称不能为空，且不超过30字符'" :maxlength="form.platformKind == 4?40:30" v-model="form.reportedName" class="input_box" :rules="[{ required: true, message: '必填' }]" />
          </van-cell-group>
          <!-- 名称 -->
          <div v-if="[4,5,6,7,8,9].indexOf(form.platformKind) > -1">
            <van-cell-group class="form_filed">
              <div class="label"> <span class="xinhao">*</span><span class="jianju">{{platformNameLabel}}</span></div>
              <van-field name="picker" :placeholder="platformNamePlaceholder" maxlength="40" v-model="form.platformName" class="input_box" :rules="[{ required: true, message: '必填' }]" />
            </van-cell-group>

          </div>
          <!-- 有害信息所在页面详细网址 -->
          <div v-if="[2,3,4,5,6,7,8,9].indexOf(form.platformKind)> -1">
            <van-cell-group class="form_filed">
              <div class="label"> <span class="xinhao">*</span><span class="jianju">有害信息所在页面详细网址</span></div>
              <van-field type="textarea" autosize name="picker" placeholder="网址格式：http://www.xxx.com或https://www.xxx.com，举报多个网址请按回车键后再输入，否则无效" maxlength="500" v-model="form.reportedLink" class="input_box" :rules="[{ required: true, message: '必填' },{ validator:this.$Common.validateInput, message: this.$Common.validateInputText }]" />
            </van-cell-group>
          </div>
        </div>
        <!--  -->
        <!-- 举报内容 -->
        <van-cell-group class="form_filed">
          <div class="label"> <span class="xinhao">*</span><span class="jianju">举报内容</span></div>
          <van-field name="picker" type="textarea" placeholder="举报内容不能为空且不能超过500个字符" maxlength="500" v-model="form.content" class="input_box textareaHeight" :rules="[{ required: true, message: '必填' }]" />
        </van-cell-group>

        <van-cell-group class="form_filed">
          <div class="label"> <span class="xinhao" v-if="(this.$route.params.id == 3 || this.$route.params.id == 8)">*</span><span class="jianju">举报材料及要件</span></div>

          <div class="van-cell van-field van-field--error">
            <div style="padding: 1vw">
              <p style="word-wrap: break-word; word-break: break-all;color: #c0c4cc;">
                {{ (this.$route.params.id == 3 || this.$route.params.id == 8) ? '请提供有害信息所在界面（如官方辟谣稿件或主管部门的通告）。材料格式支持图片（JPEG/JPG/PNG)、音频（MP3）、视频（MP4）、压缩包（RAR/ZIP）、WORD、PDF。上传的附件总大小不能超过200M，总数量不能超过10个' : '请提供有害信息所在页面截图及要件等材料。材料格式支持图片（JPEG/JPG/PNG)、音频（MP3）、视频（MP4）、压缩包（RAR/ZIP）、WORD、PDF。上传的附件总大小不能超过200M，总数量不能超过10个' }}
              </p>
              <div>
                <div class="material-list">
                  <div class="material-item" v-for="(item, index) in form.attachment" :key="index">
                    <div class="material-item-right">
                      <div class="material-item-right-flex">
                        <div class="material-item-name">
                          <img src="../../../assets/img/24gf-fileEmpty@3x.png" alt="" style="width: 5vw; vertical-align: middle" />
                          {{ `${item.name}.${item.suffix}` }}
                        </div>
                        <div class="material-item-buttons">
                          <i class="el-icon-refresh-left" v-if="item.type === 0" style="margin-right: 0.5rem" @click="uploadChange(item.oldFile, index)"></i>
                          <!-- <i class="el-icon-close"
                             v-if="item.type !== 1"
                             @click="deleteMaterial(index)"></i> -->
                          <span @click="deleteMaterial(index)">删除</span>
                        </div>
                      </div>
                      <van-progress :percentage="item.process" v-if="item.type === 2" />
                      <!-- <div v-if="item.type === 0"
                           class="upload-err">
                        上传失败!
                      </div> -->
                    </div>
                  </div>
                </div>
                <input type="file" ref="uploadInput" class="upload-file" style="display: none" @change="uploadChange" />
                <div class="material-button" :style="form.attachment.length >=2 && 'display:none'" @click.stop="uploadClick">
                  上传文件
                </div>
                <!-- <div
                  class="van-field__error-message"
                  v-if="form.attachment.length == 0"
                >
                  必填
                </div> -->
              </div>
            </div>
          </div>
        </van-cell-group>

        <van-cell-group class="form_filed">
          <div class="label">
            <span class="xinhao">*</span><span class="jianju">验证码</span>
          </div>
          <van-field name="picker" placeholder="填写验证码" v-model="form.ImgVerifyCode" class="input_box" :rules="[{ required: true, message: '必填' }]" />
          <div class="ImgCode">
            <div>
              <img :src="`data:image/png;base64,${ImgVerify}`" style="height: 10vw; width: 36vw" />
            </div>
            <div class="ImgCode_yanzheng">
              <p><span @click="yanzheng()">换一个</span></p>
            </div>
          </div>
        </van-cell-group>
        <div style="margin: 16px" class="tijiao">
          <van-button round block type="info" native-type="submit">提 交</van-button>
        </div>
        <div style="margin: 16px" class="chognzhi">
          <van-button round block type="default" native-type="button" @click="onResetValidation">重 置</van-button>
        </div>
      </van-form>
    </div>
    <div v-else>
      <AccountLogin v-if="isshowAccountLogin" @toMobileVerificationCodeLogin="changeLogin" @toPasswordRetrieval="changeLogin" />
      <MobileVerificationCodeLogin v-if="isMobileVerificationCodeLogin" @toAccountLogin="changeLogin" />
      <PasswordRetrieval v-if="isPasswordRetrieval" @toMobileVerificationCodeLogin="changeLogin" @goBackAccountLogin="changeLogin" />
    </div>
  </div>
</template>

<script>
import AccountLogin from '@/components/LoginRegistrationForm/AccountLogin'
import MobileVerificationCodeLogin from '@/components/LoginRegistrationForm/MobileVerificationCodeLogin'
import PasswordRetrieval from '@/components/LoginRegistrationForm/PasswordRetrieval'
// import { encrypt } from '@/utils/security'
import ObsClient from 'esdk-obs-browserjs/src/obs'
import { mapState, mapMutations } from 'vuex'
import { hwTemUrlUpload } from "@/utils/upload";

export default {
  name: 'RealNameReport',
  props: ['ReportTypeId', 'IsFailRegister'],
  data () {
    return {
      token: '',
      userId: '',
      params: {
        StartUpload: function () { },
        UploadProgress: function (percent, index, that) {
          that.form.attachment[index].process = percent
        },
        FileUploaded: (url, index, file) => {
          this.form.attachment[index].url = url
          this.form.attachment[index].file = file
          this.form.attachment[index].type = 1
        },
        CancelUpload: function () { }
      },
      ImgVerify: '', // 验证码
      isshowAccountLogin: true,
      isMobileVerificationCodeLogin: false,
      isPasswordRetrieval: false,
      LocationProvince: '', // 所在地
      LocationCity: '',
      LocationCounty: '',
      form: {
        realName: '', // 姓名
        gender: '', // 性别
        email: '', // 电子邮箱
        phone: '', // 手机
        Location: { province: '', city: '',county:'' }, // 所在地
        province_code: { province: '', city: '',county:'' }, // 服务地
        reportedTrade: '', // 举报领域
        damageSubKind: '', // 危害小类
        reportedPlatform: '', // 被举报平台
        reportedName: '', // 网站名称、App名称
        reportedLink: '', // 有害信息所在页面详细网址
        targetKind: '', // app定位
        AppOfficialWebsite: '',
        AppUpLoadUrl: '',
        platformKind: '', // 平台类型
        platformName: '',
        accountKind: '',
        content: '', // 举报内容
        attachment: [], // 举报材料及要件
        ImgVerifyCode: '', // 验证码
        reportSubject:'',
        exJobKind:'',
        exUnitKind:'',
        exUnitName:''
      },
      gender: '1',
      value1: 0,
      value2: 'a',
      areaList: {
        province: '请选择',
        city: '请选择',
        province_list: [],
        city_list: [],
        county_list: [],
        city_list1: [],
        county_list1: [],
        ReportingPlatform: [
          { Platform: '网站网页', id: '0' },
          { Platform: 'App', id: '1' },
          { Platform: '网络账号', id: '2' }
        ],
        targetKind: [
          { Platform: '有害信息链接', id: 1 },
          { Platform: 'App官方网址', id: 2 },
          { Platform: 'App下载地址', id: 3 }
        ],
        app: [
          {
            id: '0',
            Platform: '微信'
          },
          {
            id: 1,
            Platform: 'QQ'
          },
          {
            id: 2,
            Platform: '微博'
          },
          {
            id: 3,
            Platform: '贴吧'
          },
          {
            id: 4,
            Platform: '博客'
          },
          {
            id: 5,
            Platform: '直播平台'
          },
          {
            id: 6,
            Platform: '论坛社区'
          },
          {
            id: 7,
            Platform: '网盘'
          },
          {
            id: 8,
            Platform: '音频'
          },
          {
            id: 9,
            Platform: '其他'
          }
        ],
        reportedTradeList: [], // 举报领域
        damageSubKind: [], // 危害小类
        exJobKind: [
          { Platform: '企业人员', id: '1' },
          { Platform: '事业单位人员', id: '2' },
          { Platform: '公务员', id: '3' },
          { Platform: '学生', id: '4' },
          { Platform: '自由职业者', id: '5' },
          { Platform: '其他', id: '6' }
        ],
        exUnitKind: [
          { Platform: '机关法人', id: '1' },
          { Platform: '企业法人', id: '2' },
          { Platform: '事业单位法人', id: '3' },
          { Platform: '社会团体法人', id: '4' },
          { Platform: '其他组织', id: '5' },
        ],
      },
      // ------------------------------------------
      reportedTradeValue: '',
      damageSubKindValue: '',
      reportedPlatformValue: '',
      targetKindValue: '',
      platformKindValue: '',
      accountKindValue: '',
      exJobKindValue:'',
      exUnitKindValue:'',
      showPicker: false,
      showPickerDamage: false,
      showPickerReportedPlatform: false,
      showPickertargetKind: false,
      showPickerplatformKind: false,
      showPickeraccountKind: false,
      showPickerExJobKind:false,
      showPickerExUnitKind:false,
      province_list: [],
      city_list: [],
      county_list: [],
      pikerShow: {
        province_code__province: false,
        province_code__city: false,
        province_code__county: false,
        native_place__province1: false,
        native_place__city1: false,
        native_place__county1: false
      },
      reportedTradeList: [],
      damageSubKindList: [],
      exJobKindList:['企业人员','事业单位人员','公务员','学生','自由职业者','其他'],
      exUnitKindList:['机关法人','企业法人','事业单位法人','社会团体法人','其他组织'],
      reportedPlatformList: ['网站网页', 'App', '网络账号'],
      targetKindList: ['有害信息链接', 'App官方网址', 'App下载地址'],
      platformKindList: ['微信', 'QQ', '微博', '贴吧', '博客', '直播平台', '论坛社区', '网盘', '音频', '其他'],
      allowFileTypeList: ['jpeg', 'jpg', 'png', 'mp4', 'mov', 'mp3', 'zip', 'rar', 'pdf', 'doc', 'docx']

    }
  },
  created () {
    if(this.$route.params.id == 7){
      this.areaList.ReportingPlatform = [
          { Platform: '网站网页', id: '0' }
        ],
      this.reportedPlatformList = ['网站网页']
      this.reportedPlatformValue = '网站网页'
      this.form.reportedPlatform = '0'
      this.subId = this.$route.params.subId
      if(this.$route.params.subId && (this.$route.params.subId == 588 || this.$route.params.subId == 590)){
          this.form.reportSubject = ''
      }else{
          this.form.reportSubject = '1'
      }
    }
    // 用户是否登录
    const token =
      localStorage.getItem('userInfo') &&
      JSON.parse(localStorage.getItem('userInfo')) &&
      JSON.parse(localStorage.getItem('userInfo')).token
    if (token) {
      // 显示登陆头像  已登录显示表单
      this.setActiveName(true)
      this.token = token
      // 请求用户信息
      this.userinfo()
      // 验证码
      this.yanzheng()
    }

    // areaList市区联动查询
    this.$Api.areaList({ type: '1', parentId: '1' }).then((res) => {
      this.province_list = res.list
      this.areaList.province_list = res.list
    })
    // 行业信息
    this.$Api.dictionaryList({ type: '0' }).then((res) => {
      this.reportedTradeList = res.list.map(r => r.key)
      this.areaList.reportedTradeList = res.list
    })
    // 危害小类
    this.$Api
      .reportTypeQueryReportType({ parentId: this.ReportTypeId })
      .then((res) => {
        if(this.$route.params.subId){
          this.damageSubKindList = res.filter(item => item.id == this.$route.params.subId).map(r => r.typeName)
          this.form.damageSubKind = Number(this.$route.params.subId)
          this.damageSubKindValue = this.damageSubKindList[0]
        }else{
          this.damageSubKindList = res.map(r => r.typeName)
        }
        
        this.areaList.damageSubKind = res
      })
    // 验证码
    this.yanzheng()
    // 模拟举报失败回显数据
    if (this.IsFailRegister && localStorage.getItem('reportForm')) {
      setTimeout(() => {
        const formLi = JSON.parse(localStorage.getItem('reportForm'))
        this.form = formLi

        this.reportedTradeValue = formLi.reportedTrade && this.areaList.reportedTradeList.find(v => v.id == formLi.reportedTrade).key
        this.damageSubKindValue = formLi.damageSubKind && this.areaList.damageSubKind.find(v => v.id == formLi.damageSubKind).typeName
        this.reportedPlatformValue = formLi.reportedPlatform && this.areaList.ReportingPlatform.find(v => v.id == formLi.reportedPlatform).Platform
        this.targetKindValue = formLi.targetKind && this.areaList.targetKind.find(v => v.id == formLi.targetKind).Platform
        this.platformKindValue = formLi.platformKind && this.areaList.app.find(v => v.id == formLi.platformKind).Platform
        this.accountKindValue = formLi.accountKind && this.accountNatureList.find(v => v.value == formLi.accountKind).name
      }, 900)
    }
  },
  methods: {
    ...mapMutations(['setActiveName']),
    onConfirmCity (value, filed, clearFiled, type) {
      this.pikerShow[filed] = false
      this.form[filed.split('__')[0]][filed.split('__')[1]] = value.id
      if(value.id == 1000000){
        if(type == 1 || type == 2){
          this.form.province_code.city = 1000000
          this.form.province_code.county = 1000000
        }
      }else{
        if (clearFiled) {
          this.form[clearFiled.split('__')[0]][clearFiled.split('__')[1]] =
            ''
        }
        if (type === '1') {
          type === '1' && (this.form.province_code.county = '')
          this.$Api.areaList({ type: '2', parentId: value.id }).then((res) => {
            type === '1' && (this.city_list = res.list)
          })
        }else if(type === '2'){
          this.$Api.areaList({ type: '3', parentId: value.id }).then((res) => {
            this.county_list = res.list
          })
        }
      }
      
    },
    onConfirms (value, filed, clearFiled, type) {
      this.form.reportedTrade = this.areaList.reportedTradeList[filed].id
      this.reportedTradeValue = value
      this.showPicker = false
    },
    onConfirmDamage (value, filed, clearFiled, type) {
      this.form.damageSubKind = this.areaList.damageSubKind.find(item => item.typeName == value).id
      this.damageSubKindValue = value
      this.showPickerDamage = false
    },
    onConfirmReportedPlatform (value, filed, clearFiled, type) {
      this.form.reportedPlatform = this.areaList.ReportingPlatform[filed].id
      this.reportedPlatformValue = value
      this.showPickerReportedPlatform = false
    },
    onConfirmsExJobKind (value, filed, clearFiled, type) {
      this.form.exJobKind = this.areaList.exJobKind[filed].id
      this.exJobKindValue = value
      this.showPickerExJobKind = false
    },
    onConfirmsExUnitKind (value, filed, clearFiled, type) {
      this.form.exUnitKind = this.areaList.exUnitKind[filed].id
      this.exUnitKindValue = value
      this.showPickerExUnitKind = false
    },
    onConfirmtargetKind (value, filed, clearFiled, type) {
      this.form.targetKind = this.areaList.targetKind[filed].id
      this.targetKindValue = value
      this.showPickertargetKind = false
    },
    onConfirmplatformKind (value, filed, clearFiled, type) {
      this.form.platformKind = this.areaList.app[filed].id
      this.platformKindValue = value
      this.showPickerplatformKind = false
    },
    onConfirmaccountKind (value, filed, clearFiled, type) {
      this.form.accountKind = this.accountNatureList[filed].value
      this.accountKindValue = value
      this.showPickeraccountKind = false
    },
    reportedPlatformChange () {
      this.form.reportedName = ''
    },
    // 请求用户信息
    userinfo () {
      this.$Api
        .userGet({}, { noToast: true })
        .then((res) => {
          setTimeout(() => {
            this.userId = res.id
            this.form.realName = res.name
            this.form.email = res.email
            this.form.nickname = res.nickname
            this.form.phone = res.phone
            this.form.gender = res.gender
            this.LocationProvince = res.provinceCode
            this.LocationCity = res.cityCode
            this.LocationCounty = res.countyCode
            const provinceArr = this.areaList.province_list.filter(r => r.id == res.provinceCode)
            this.form.Location.province = provinceArr && provinceArr[0] && provinceArr[0].name
            // const cityArr = this.areaList.province_list.filter(r => r.id == res.cityCode)
            // this.form.Location.city = cityArr && cityArr[0] && cityArr[0].name
            // const countyArr = this.areaList.province_list.filter(r => r.id == res.countyCode)
            // this.form.Location.county = countyArr && countyArr[0] && countyArr[0].name
            if (res.kind == 1) {
              this.form.wodeshenfen = [{ shenfen: '义务监督员', state: 1 }]
            }
            if (res.kind == 2) {
              this.form.wodeshenfen = [{ shenfen: '志愿者', state: 1 }]
            }
          }, 500)
        })
        .catch()
    },
    onSubmit () {
      // localStorage.setItem('reportForm', JSON.stringify(this.form))// 实验数据，用完记得删
      this.$toast.loading({
        duration: 1000, // 持续展示 toast
        forbidClick: true
      })
      if ((this.$route.params.id == 3 || this.$route.params.id == 8) && this.form.attachment.length === 0) {
        this.$toast('请上传举报材料及要件')
        return
      }
      if (this.form.attachment.find(item => item.type === 0)) {
        this.errorTooltip = '有失败的文件！请检查！'
        this.$dialog.confirm({
          title: '提示',
          message: '上传失败！请检查文件格式'
        })
        return
      }
      const {
        // eslint-disable-next-line camelcase
        realName, gender, email, phone, province_code, reportedTrade, damageSubKind, reportedPlatform, reportedName, reportedLink, targetKind, AppOfficialWebsite, platformKind, accountKind, content, attachment, platformName, ImgVerifyCode,
        reportSubject,
        exJobKind,
        exUnitKind,
        exUnitName
      } = this.form
      this.$CookieApi
        .reportAddReport({
          kind: 0,
          realName: realName,
          gender: gender,
          email,
          phone: phone,
          provinceSelf: this.LocationProvince,
          citySelf: this.LocationCity,
          countySelf: this.LocationCounty,
          provinceReported: province_code.province,
          cityReported: province_code.city,
          countyReported: province_code.county,
          damageKind: this.$route.params.id,
          reportedTrade: reportedTrade,
          damageSubKind: damageSubKind,
          reportedPlatform: reportedPlatform,
          platformKind: platformKind,
          accountKind: accountKind,
          reportedName: reportedName,
          platformName: platformName,
          reportedLink: reportedLink,
          repotedHomeSite: AppOfficialWebsite,
          targetKind: targetKind,
          content: content,
          attachment: JSON.stringify(attachment),
          // files: attachment,
          ImgVerifyCode: ImgVerifyCode,
          reportSubject,
          exJobKind:reportSubject ==='1' ?exJobKind:'',
          exUnitKind:reportSubject ==='2' ?exUnitKind:'',
          exUnitName:reportSubject ==='2' ?exUnitName:''
        }, '',
          {
            callback: (res) => {
              if (res.status == 432 || res.status == 452) {
                return this.$toast(res.message)
              } else if (res.status != 0) {
                localStorage.setItem('reportForm', JSON.stringify(this.form))
                this.$emit('tojubaoChangestate', {
                  state: false,
                  name: 'ReportRegister',
                  data: '',
                  type: this.$route.params.id,
                  kind: 0
                })
              }
            },
            noToast: true
          })
        .then((res) => {
          if (res) {
            // 成功
            this.$emit('tojubaoChangestate', {
              state: true,
              name: 'ReportRegister',
              data: res
            })
            localStorage.removeItem('reportForm')
          } else {
            // localStorage.setItem('reportForm', JSON.stringify(this.form))
            // this.$emit('tojubaoChangestate', {
            //   state: false,
            //   name: 'ReportRegister',
            //   data: '',
            //   type: this.$route.params.id,
            //   kind: 0
            // })
          }
        })
        .catch(() => {
          // localStorage.setItem('reportForm', JSON.stringify(this.form))
          // this.$emit('tojubaoChangestate', {
          //   state: false,
          //   name: 'ReportRegister',
          //   data: '',
          //   type: this.$route.params.id,
          //   kind: 0
          // })
        })
    },
    onFailed (val) {
      console.log(val)
      this.$toast('还有必填项未完成')
    },
    provinceChange1 () {
      this.areaList.city_list1 = []

      this.$Api
        .areaList({ type: '2', parentId: this.form.province_code.province })
        .then((res) => {
          this.areaList.city_list1 = res.list
        })
    },
    addFiles () { },
    yanzheng () {
      this.$CookieApi
        .reportGetImgVerifyCode({}, '', { noToast: true })
        .then((res) => {
          if (res) {
            this.ImgVerify = res
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    onResetValidation () {
      this.form.AppOfficialWebsite = ''
      this.form.AppUpLoadUrl = ''
      this.form.ImgVerifyCode = ''
      this.form.province_code = ''
      this.form.accountKind = ''
      this.form.attachment = ''
      this.form.content = ''
      this.form.damageSubKind = ''
      this.form.nickname = ''
      this.form.platformKind = ''
      this.form.platformName = ''
      this.form.reportedLink = ''
      this.form.reportedName = ''
      this.form.reportedPlatform = ''
      this.form.reportedTrade = ''
      this.form.targetKind = ''
      this.form.province_code = { province: '', city: '' }
      this.form.attachment = []
      this.form.reportSubject = ''
      this.form.exJobKind = ''
      this.form.exUnitKind = ''
      this.form.exUnitName = ''
      this.reportedTradeValue = ''
      this.damageSubKindValue = ''
      this.reportedPlatformValue = ''
      this.targetKindValue = ''
      this.platformKindValue = ''
      this.accountKindValue = ''
      this.exJobKindValue = ''
      this.exUnitKindValue = ''
    },
    async asValidator (val) {
      return new Promise((resolve) => {
        if (
          val.match(/[^\u4E00-\u9FA5A-Za-z·]/) != null ||
          val.match(/··/) != null
        ) {
          return resolve(false)
        }
      })
    },
    validateForm () { },
    changeLogin (e) {
      if (e == 'MobileVerificationCodeLogin') {
        this.isshowAccountLogin = false
        this.isMobileVerificationCodeLogin = true
        this.isPasswordRetrieval = false
      } else if (e == 'AccountLogin') {
        this.isshowAccountLogin = true
        this.isMobileVerificationCodeLogin = false
        this.isPasswordRetrieval = false
      } else if (e == 'PasswordRetrieval') {
        this.isshowAccountLogin = false
        this.isMobileVerificationCodeLogin = false
        this.isPasswordRetrieval = true
      }
    },
    isloginChange (s) {
      this.setActiveName(s)
    },
    uploadClick () {
      if (this.form.attachment.length >= 10) {
        this.$toast('当前列表文件数量已超限，无法继续上传！')
        return
      }
      const input = this.$refs.uploadInput
      input && input.click()
    },
    async uploadChange (e, position) {
      this.$toast.loading({
        duration: 1000, // 持续展示 toast
        forbidClick: true
      })
      let file
      if (e.target) {
        file = e.target.files[0]
      } else {
        file = e
      }
      if (!file) {
        this.clearInputFile(this.$refs.uploadInput)
        return
      }
      const fileName = file.name
        .slice(0, file.name.lastIndexOf('.'))
        .slice(0, 20)
      const suffix = file.name.slice(file.name.lastIndexOf('.') + 1)
      const isAllowFile = this.allowFileTypeList.indexOf(file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase()) > -1

      // this.allowFileTypeList.indexOf(file.type) > -1
      // eslint-disable-next-line no-constant-condition
      if (isAllowFile) {
        if (file.size <= 1024 * 1024 * 200) {
          const that = this
          let index
          if(position != undefined){
              index = position
              this.form.attachment[index] = {name:fileName,process:0,file:'',type:2,suffix}
          }else{
              this.form.attachment.push({name:fileName,process:0,file:'',type:2,suffix}) //type 上传状态类型 0->失败 1->成功 2->上传中
              index = this.form.attachment.length - 1
          }
          // const res = await this.$Api.getLeadToken({ key: file.name })
          const res = await this.$Api.getImageToken({ contentType:file.type,fileName:file.name })
          console.log(res, 'res')
          if(res.keyTokenParis[0].token) return hwTemUrlUpload(file, res,(percent, onCancel) => {
              this.form.attachment[index].process = parseInt(percent)
              this.form.attachment[index].onCancel = onCancel
          }, ({src, fileName}) => {
              if (src) {
                  this.form.attachment[index].url = src
                  this.form.attachment[index].file = fileName
                  this.form.attachment[index].type = 1
              } else {
                  this.form.attachment[index].type = 0
              }
          })

          // 上传改版  以下代码为旧版
          this.token = res

          // 上传云

          const uploader = new ObsClient({
            access_key_id: this.token.accessKey,
            secret_access_key: this.token.secretKey,
            server: this.token.endpoint,
            security_token: this.token.keyTokenParis[0].token,
            timeout: 24 * 60 * 60
          })

          // let index
          if (position != undefined) {
            index = position
            this.form.attachment[index] = {
              name: fileName,
              process: 0,
              file: '',
              type: 2,
              suffix
            }
          } else {
            this.form.attachment.push({
              name: fileName,
              process: 0,
              file: '',
              type: 2,
              suffix
            }) // type 上传状态类型 0->失败 1->成功 2->上传中
            index = this.form.attachment.length - 1
          }
          const options = {
            Bucket: this.token.bucket,
            Key: this.token.keyTokenParis[0].key,
            SourceFile: file,
            ProgressCallback: function (
              transferredAmount,
              totalAmount,
              totalSeconds
            ) {
              that.params.UploadProgress(
                parseInt((transferredAmount * 100) / totalAmount),
                index,
                that
              )
            }
          }

          uploader.putObject(options, function (err, res) {
            that.FileUploaded(err, uploader, index, file)
          })
          //
        } else {
          this.$dialog.alert({
            title: '提示',
            message: '上传失败！文件总大小已超过200M！',
            theme: 'round-button',
            confirmButtonText: '知道了'
          })
        }
      } else {
        this.$dialog.alert({
          title: '提示',
          message: '上传失败！请检查材料格式！',
          theme: 'round-button',
          confirmButtonText: '知道了'
        })
      }
      this.clearInputFile(this.$refs.uploadInput)
    },
    FileUploaded (err, uploader, index, flle) {
      var key = this.token.keyTokenParis[0].key
      var sign = this.token.keyTokenParis[0].sign
      if (err) {
        console.log(err)
        return
      }
      var url = this.token.host + '/' + key
      if (sign) {
        url = url + '?' + sign
      }
      this.params.FileUploaded(url, index, flle)
      uploader = null
    },
    deleteMaterial (index) {
      if (this.form.attachment[index].type === 2) {
        this.form.attachment[index].onCancel()
      }
      this.form.attachment.splice(index, 1)
      this.clearInputFile(this.$refs.uploadInput)
    },
    clearInputFile (inputEl) {
      if (!inputEl) return
      inputEl.value = ''
    }
  },
  computed: {
    ...mapState(['ActiveName']),
    accountKindList () {
      if (this.form.platformKind === '0') {
        return ['个人', '公众', '群组']
      } else if (this.form.platformKind === 1) {
        return ['个人', '群组']
      } else if (this.form.platformKind === 2) {
        return ['认证', '非认证']
      }
      return true
    },
    accountNatureList () {
      if (this.form.platformKind === '0') {
        return [
          {
            name: '个人',
            value: '0'
          },
          {
            name: '公众',
            value: 1
          },
          {
            name: '群组',
            value: 2
          }
        ]
      } else if (this.form.platformKind === 1) {
        return [
          {
            name: '个人',
            value: '0'
          },
          {
            name: '群组',
            value: 2
          }
        ]
      } else if (this.form.platformKind === 2) {
        return [
          {
            name: '认证',
            value: 3
          },
          {
            name: '非认证',
            value: 4
          }
        ]
      }
      return true
    },
    platformNameLabel () {
      if (this.form.platformKind === 4) {
        return '博客平台'
      } else if (this.form.platformKind === 5) {
        return '直播平台名称'
      } else if (this.form.platformKind === 6) {
        return '论坛社区名称'
      } else if (this.form.platformKind === 7) {
        return '网盘名称'
      } else if (this.form.platformKind === 8) {
        return '音频平台名称'
      } else if (this.form.platformKind === 9) {
        return '平台名称'
      }
      return true
    },
    platformNamePlaceholder () {
      if (this.form.platformKind === 4) {
        return '博客平台名称不能为空，且不超过40字符'
      } else if (this.form.platformKind === 5) {
        return '直播平台名称不能为空，且不超过40字符'
      } else if (this.form.platformKind === 6) {
        return '论坛平台名称不能为空，且不超过40字符'
      } else if (this.form.platformKind === 7) {
        return '网盘平台名称不能为空，且不超过40字符'
      } else if (this.form.platformKind === 8) {
        return '音频平台名称不能为空，且不超过40字符'
      } else if (this.form.platformKind === 9) {
        return '平台名称不能为空，且不超过40字符'
      }
      return true
    },
    queryArea () {
      return function (id) {
        if (id) {
          this.$axios.get(this.$ApiInfo.common.getAreaNameById, { id }).then(async res => {
            this.$forceUpdate()
            await this.$nextTick(() => {

            })
            return res.data.data[0].name
          })
          // return id
        }
      }
    },
    province_val () {
      // < !-- : value = "form.province_code.province ? province_list.find((v) => v.id / 1 === form.province_code.province).name: ''" -- >
      const provinceValue = this.form.province_code.province ? this.province_list.find((v) => v.id / 1 === this.form.province_code.province) : {}
      return provinceValue && provinceValue.name
    },
    city_val () {
      // < !-- : value = "form.province_code.city ? city_list.find( (v) => v.id / 1 === form.province_code.city ).name : '' " -- >
      const cityValue = this.form.province_code.city ? this.city_list.find((v) => v.id / 1 === this.form.province_code.city) : {}
      return cityValue && cityValue.name
    },
    county_val () {
      // < !-- : value = "form.province_code.city ? city_list.find( (v) => v.id / 1 === form.province_code.city ).name : '' " -- >
      const countyValue = this.form.province_code.county ? this.county_list.find((v) => v.id / 1 === this.form.province_code.county) : {}
      return countyValue && countyValue.name
    }
  },
  watch: {
    LocationProvince (a, b) {
      setTimeout(() => {
        this.$Api.areaList({ type: '2', parentId: a }).then((res) => {
          const CityArr = res.list.filter(r => r.id == this.LocationCity)
          this.form.Location.city = CityArr && CityArr[0] && CityArr[0].name
        }, 0)
        this.$Api.areaList({ type: '3', parentId: this.LocationCity }).then((res) => {
          const countyArr = res.list.filter(r => r.id == this.LocationCounty)
          this.form.Location.county = countyArr && countyArr[0] && countyArr[0].name
        }, 0)
      })
    },
    ActiveName: {
      immediate: true,
      handler () {
        if (localStorage.getItem('userInfo')) {
          this.setActiveName(true)
        } else {
          this.setActiveName(false)
        }
        this.userinfo()
        this.yanzheng()
      }
    },
    province_val () {
      this.$Api.areaList({ type: '2', parentId: this.form.province_code.province }).then((res) => {
        this.city_list = res.list
      })
    }

  },
  components: {
    AccountLogin,
    MobileVerificationCodeLogin,
    PasswordRetrieval
  }
}
</script>

<style lang="scss" scoped>
.quyu {
  display: flex;
  span {
    font-size: 3.73332vw;
    color: #646566;
    text-align: left;
    word-wrap: break-word;
  }
}
.yanzhengma {
  display: block;
  // display: flex;
  // justify-content: start;
  // align-items: center;
  div {
    margin-bottom: 5vw;
    text-align: center;
  }
  :nth-child(2) {
    // width: 20vw;
    margin-bottom: 1vw;
  }
  :nth-child(3) {
    // width: 20vw;
    margin-bottom: 1vw;
    color: #122da7;
  }
  :nth-child(4) {
    text-align: start;
  }
  .btn_code {
    display: flex;
    justify-content: center;
  }
}

.biaoge {
  width: 45%;
  height: 8vw;
  border: 2px solid rgba(0, 0, 0, 0.15);
  border-radius: 1vw;
}
.biaoge1 {
  width: 100%;
  height: 8vw;
  border: 2px solid rgba(0, 0, 0, 0.15);
  border-radius: 1vw;
}
.biaoge2 {
  border: 2px solid rgba(0, 0, 0, 0.15);
}
.van-field__error-message {
  font-size: 3vw;
}
.xingbieanniu {
  width: 25vw;
  height: 9vw;
  text-align: center;
  line-height: 9vw;
  background: #f6f8fa;
  margin: 0vw 2vw;
}
.xingbieanniudianji {
  font-weight: bold;
  color: #002fa7;
  background: #e9f1ff;
  border: 1px solid #002fa7;
}
.material-button {
  background-color: #002fa7;
  color: #fff;
  font-size: 4vw;
  font-weight: 700;
  width: 80%;
  height: 10vw;
  line-height: 10vw;
  text-align: center;
  margin-left: 10vw;
  margin-top: 3vw;
}
.material-item-right-flex {
  display: flex;
  justify-content: space-between;
  background-color: #f6f8fa;
  margin: 2vw 0;
}
.material-item-buttons {
  display: flex;
  align-items: center;
}
.ImgCode {
  // background-color: rgb(198, 58, 58);
  text-align: center;
  margin-top: 3.2vw;
  .ImgCode_yanzheng {
    margin-top: 3.2vw;
    margin-bottom: 10.66vw;
    color: #002fa7;
  }
}
</style>
